import { z } from "zod";

export const EmployeeIdSchema = z.uuid().brand<'EmployeeId'>();

export type EmployeeId = z.infer<typeof EmployeeIdSchema>;
